type OAuthError = {
  error: string;
  error_description: string;
};

function isOAuthError(value: any): value is OAuthError {
  return value && "error" in value && "error_description" in value;
}

export function isInvalidRefreshToken(err: Error | undefined): boolean {
  if (isOAuthError(err)) {
    const { error, error_description } = err;
    return error === "invalid_grant" && error_description?.includes("invalid refresh token");
  }
  return false;
}
